module.exports = __webpack_public_path__ + "media/images/products/products/h5-0e60a25c0b9223cad445dadc27149ccb.jpg";